import { delay } from 'Common/utils';

export const checkCaptcha = (val) => {
  console.log('in captcha');
  return delay(500).then(() => new Promise((resolve) => resolve({ body: JSON.stringify({ valid: false }) })));
};

export const fetchGender = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Эркак' },
      { id: 2, value: 'Аёл' },
    ];
  });
};

export const fetchPrivacy = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Ҳа' },
      { id: 2, value: 'Йўқ' },
    ];
  });
};

export const fetchStatus = () => {
  return delay(500).then(() => {
    return [
      { id: 1, value: 'Банд-ишлайди' },
      { id: 2, value: 'Ишсиз' },
      { id: 3, value: 'Нафақахўр' },
      { id: 4, value: 'Талаба' },
      { id: 0, value: '-' },
    ];
  });
};

export const fetchJuridicalList = () => {
  return delay(500).then(() => {
    return {
      body: JSON.stringify([
        {
          id: '"Yagona integrator UZINFOCOM" MCHJ',
          tin: 204118319,
          title: '"Yagona integrator UZINFOCOM" MCHJ',
        },
        {
          id: '"Mininfocom"',
          tin: 123456789,
          title: '"Mininfocom"',
        },
      ]),
    };
  });
};

export const fetchRegions = () => {
  return delay(500).then(() => {
    return {
      body: JSON.stringify([
        { id: 1, title: 'Toshkent' },
        { id: 2, title: 'Boshqakent' },
        { id: 9999, title: 'Chet el' },
      ]),
    };
  });
};

export const fetchDistricts = (regionId) => {
  return delay(500).then(() => {
    return {
      body: JSON.stringify([
        { id: 1, title: 'Jidazor' },
        { id: 2, title: 'Uzumzor' },
      ]),
    };
  });
};

export const fetchGuid = () => {
  return delay(500).then(() => {
    return { body: '"slkdjfksljfdslkjfddslkfjsf"' };
  });
};

export const fetchPhonePattern = (id) => {
  return delay(500).then(() => {
    return {
      body: JSON.stringify({
        pattern: '+720000000',
        mask: '+721111111',
      }),
    };
  });
};

export const fetchCountries = () => {
  return delay(500).then(() => {
    return {
      body: [
        { id: 1, title: 'Ukraina' },
        { id: 2, title: 'USA' },
      ],
    };
  });
};

// new endpoints
export const fetchMakhallas = (regionId, districtId) => {
  return delay(500).then(() => {
    return {
      body: JSON.stringify([
        { id: 1, title: 'Bodomzor' },
        { id: 2, title: 'Giloszor' },
      ]),
    };
  });
};

export const uploadFile = (data) => {
  return delay(500).then(() => {
    return {
      ok: true,
      body: { id: Math.floor(Math.random() * 10), hash: 'hgjkdshgdsjkfhgkl2214243fgsfd' },
    };
  });
};

export const deleteUploadedFile = (params) => {
  return delay(500).then(() => {
    return {
      ok: true,
      body: {
        success: true,
        message: 'deleted successfully',
      },
    };
  });
};

export const sendCode = (phone) => {
  return delay(500).then(() => {
    return {
      ok: true,
      body: JSON.stringify({ success: true, message: 'hello world' }),
    };
  });
};

export const checkCode = (data) => {
  return delay(500).then(() => {
    return {
      ok: true,
      body: JSON.stringify({ success: true }),
    };
  });
};

export const sendUserData = (data) =>
  delay(500).then(() => ({
    ok: true,
    body: {
      status: true,
      result: {
        birthday: '2001-09-04',
        current_address: 'МИРАБАДСКИЙ ТУМАН - ҚЎЙЛИҚ 3-КВАРТАЛ',
        first_name: 'AZIMJON',
        gender: 'm',
        last_name: 'ABDULLAYEV',
        middle_name: 'ZOKIROVICH',
        pin_fl: '50409010201628',
        region_id: 1,
        district_id: 1,
      },
      message: 'Данные успешно обработаны',
    },
  }));

export const sendFeedback = (data) =>
  delay(500).then(() => ({
    ok: true,
    body: {
      status: true,
      message: 'Successfully saved',
    },
  }));

import request from 'superagent';

export const fetchCaptcha = () => {
  const url = 'http://neww.pm.track.uz/site/captcha?refresh=1';
  const req = request.get(url);
  return req;
};

export const fetchSendDraft = () =>
  delay(500).then(() => ({
    body: {
      authority_id: 9223,
      birthday: '2001-09-04',
      id: 708,
      current_address: 'ЮКСАЛИШ МФЙ, КУЙЛИК-3 ДАХАСИ,  uy:15 xonadon:29',
      description: null,
      district_id: 1726273,
      email: 'centrsistema@bk.ru',
      employment_id: null,
      first_name: 'AZIMJON',
      form_type: 10,
      gender: 'm',
      is_juridical: false,
      is_public: null,
      juridical_name: '',
      juridical_tin: null,
      last_name: 'ABDULLAYEV',
      mahalla_id: null,
      middle_name: 'ZOKIROVICH',
      persecution_authority_name: null,
      created_at: '2022-11-22 11:41:01',
      persecution_request_no: null,
      phone: '+998909498762',
      pin_fl: 50409010201628,
      region_id: 1726,
      section_type: null,
      source_id: 1,
      user_file: null,
    },
  }));

export const fetchGetDraft = () =>
  delay(500).then(() => ({
    body: {
      status: true,
      result: {
        id: 515,
        author_id: 2,
        authority_id: 1,
        first_name: 'SEMYON',
        last_name: 'POROT',
        middle_name: 'ILICH',
        region_id: 1,
        district_id: 2,
        mahalla_id: 2,
        gender: 'm',
        current_address: 'ЮКСАЛИШ МФЙ, КУЙЛИК-3 ДАХАСИ,  uy:28 xonadon:26',
        birthday: '31.07.1998',
        email: '4a3c_98@mail.ru',
        phone: null,
        pin_fl: 33107986530025,
        user_file: [{ file_id: 1, name: 'azimjonis' }],
        is_public: 0,
        is_juridical: false,
        description: 'test 1234',
        juridical_name: null,
        source_id: 1,
        employment_id: 1,
        app_type: 'pm.track.uz:8011',
        section_type: null,
        created_at: '2022-03-01 21:17:14',
        updated_at: '2022-03-02 09:09:52',
        request_id: null,
        request_no: null,
        token: null,
        sent_date: null,
        form_type: 4,
        persecution_authority_name: 'Just Organization',
        persecution_request_no: '123-s/qb-request',
      },
    },
  }));

export const fecthGetUserFiles = () =>
  delay(500).then(() => ({
    body: {
      downloaded: [' учун Шаблон (2).rar', 'digital-7.zip'],
      removed: [],
    },
  }));

export const sendTin = (data) =>
  delay(1000).then(() => ({
    ok: true,
    body: {
      status: true,
    },
  }));

export const fetchInvalidList = () =>
  delay(500).then(() => ({
    body: JSON.stringify([
      {
        id: 1,
        title: 'Ногиронлиги йўқ',
      },
      {
        id: 2,
        title: '1-гуруҳ',
      },
      {
        id: 3,
        title: '2-гуруҳ',
      },
      {
        id: 4,
        title: '3-гуруҳ',
      },
    ]),
  }));



// WEBPACK FOOTER //
// ./src/application-form/fake-api.js